module.exports = __webpack_public_path__ + "img/icon-media.d731b45a.svg";